import type { PopupButton } from '@typeform/embed-react'
import dynamic from 'next/dynamic'
import type { FunctionComponent } from 'react'

import styles from './action-typeform.module.scss'
import type { ActionOpenTypeformFragment } from '@graphql/fragments/ActionOpenTypeformFragment.graphql'

const TypeformPopup = dynamic(
    () =>
        import('@typeform/embed-react').then((m) => m.PopupButton) as Promise<
            typeof PopupButton
        >,
    { ssr: false },
)

export const ActionOpenTypeform: FunctionComponent<Props> = ({
    publicUrl,
    title,
}) => {
    const formId = publicUrl?.split('/').pop()

    if (!formId) return null
    return (
        <TypeformPopup
            autoResize
            size={50}
            id={formId}
            className={styles.button}
        >
            <span>{title}</span>
        </TypeformPopup>
    )
}

type Props = Omit<ActionOpenTypeformFragment, 'sys'>
